import {ExpeditionsState} from './state/expeditions.state';

export const expeditionsStates = [
    ExpeditionsState
];
